// extracted by mini-css-extract-plugin
export default {"auth_container":"style_auth_container__7QuRu","auth_form":"style_auth_form__8Z5aH","form_control":"style_form_control__gDq0L","button":"style_button__X4deJ"};